
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/menus",
      function () {
        return require("private-next-pages/[slug]/menus/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/menus"])
      });
    }
  